import { ga } from 'js/analytics/adapters'

// Amplitude's `user_purchase_premium` for the upgrade scenario is emitted once
// by trackCompletedPayment (with action_name: 'upgrade' and full price data).
// This tracker keeps the GA-only "Completed upgrade" event to avoid
// double-counting the purchase in Amplitude.
export const trackCompletedUpgrade = () => {
  ga.track('click', {
    eventCategory: 'Upgrade',
    eventLabel: 'Completed upgrade',
    eventValue: 0,
  })
}
